import React from "react";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { BsExclamationDiamond } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(1),
      padding: "8%",
    },
  },
}));

const SelectSingleValues = ({
  showLable,
  heading,
  placeholder,
  errors,
  refs,
  name,
  className,
  selected,
  onSelect,
  label,
  size,
  values,
  disabled,
}) => {
  const classes = useStyles();

  const errorText = (
    <p>
      <BsExclamationDiamond /> {errors}
    </p>
  );
  return (
    <div className={classes.root}>
      {showLable && <div className="fieldHeading">{heading}</div>}
      <Autocomplete
        id="tags-outlined"
        options={values}
        getOptionLabel={(option) => option.name || ""}
        getOptionSelected={(option, selected) =>
          option.name === selected.name || ""
        }
        defaultValue={selected || ""}
        value={selected || ""}
        onChange={(event, value) => {
          onSelect(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            disabled={disabled || false}
            placeholder={placeholder}
            InputLabelProps={{ shrink: true }}
            label={label}
            variant="outlined"
            inputRef={refs}
            size={size || "small"}
            id={name}
            name={name}
            error={errors ? true : false}
            helperText={errors ? errorText : null}
          />
        )}
      />
    </div>
  );
};

export default SelectSingleValues;
